import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

const admissionsCrudPermissions = buildCrudPermissions("Academics", "Admissions");

export const ADMISSIONS_PERMISSIONS = {
  ...admissionsCrudPermissions,
  onlineApplication: permissionId("Academics", "Admissions", "onlineApplication"),
  approveApplication: permissionId("Academics", "Admissions", "approveApplication"),
} as const;
